import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class UsersService {
  private apiUrl = environment.API_ENDPOINT;
  headers: any;

  constructor(private http: HttpClient, private router: Router) { 
    this.headers = {
      'Content-Type': 'application/json'
    }
  }
  
  /**
   * login user service
   * @param user 
   */
  loginUser(user): Observable<any> {
    //console.log(user);
    return this.http.post(this.apiUrl + 'users/login', user, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  checkLogin(): Observable<any> {
    return this.http.get(this.apiUrl + 'users/checkLogin')
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  /*Is Auth check for user
    @param: NULL
  */
  isAuth() {
    try {
      if (localStorage.user_login) {
        if (JSON.parse(localStorage.user_login) && JSON.parse(localStorage.user_login).token) {
          return true;
        }
        else {
          return false;
        }
      }
    }
    catch (err) {
      return false;
    }
  }

  /*Set user session
    @param: data
  */
  setSession(data) {
    localStorage.setItem('user_login', JSON.stringify(data));
  }

  /*Read user session
    @param: data
  */
  readSession(): Observable<any>  {
    return JSON.parse(localStorage.getItem('user_login'));
  }

  /*User Logout
    @param: NULL
  */
  logout(language) {
    localStorage.removeItem('user_login');
    localStorage.clear();
    this.router.navigate([language + '/']);
  }

  sendOTP(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/forgotPassword', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  verifyOTP(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/verifyOTP', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  resetPassword(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/resetPassword', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  resetOTP(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/resendOTP', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  /**
   * profile user service
   * @param user 
   */
  getProfile(): Observable<any> {
    return this.http.get(this.apiUrl + 'users/profile', { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  editProfile(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/editProfile', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  changePassword(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/changePassword', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  driver_list(courierID): Observable<any> {
    return this.http.get(this.apiUrl + 'users/listDriver/' + courierID , { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  addDriver(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/addDriver', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  addTruck(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/addTruck', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getDriverDetail(data): Observable<any> {
    return this.http.get(this.apiUrl + 'users/getDriver/' + data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  deleteDriver(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/removeDriver', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  deleteTruck(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/removeTruck', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getTruckDetail(data): Observable<any> {
    return this.http.get(this.apiUrl + 'users/getTruck/' + data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  deleteVehicle(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/removeVehicle', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  addVehicle(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/addVehicle', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getVehicleDetail(data): Observable<any> {
    return this.http.get(this.apiUrl + 'users/getVehicle/' + data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  supportMsg(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/supportMail', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  updateVehicle(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/updateVehicle', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  updateTruck(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/updateTruck', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getInsuranceAmount(): Observable<any> {
    return this.http.get(this.apiUrl + 'get-industry-details/getInsuranceAmount')
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getTruckCount(): Observable<any> {
    return this.http.get(this.apiUrl + 'get-industry-details/getTruckCount')
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  getTruckType(): Observable<any> {
    return this.http.get(this.apiUrl + 'get-industry-details/getTruckType')
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  updateDriver(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/updateDriver', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  checkPassword(data): Observable<any> {
    return this.http.post(this.apiUrl + 'users/chkpassword', data, { headers: this.headers })
      .pipe(
        catchError(this.handleError('getUser', []))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
